import { InfoCircleOutlined } from '@ant-design/icons';
import { AxiosError } from 'axios';
import { mutateConfig } from '../../api/queryBase';
import { ArrowRightIcon, CloseIcon } from '../icons';
import { getErrorMessage, openNotification } from '../../utils/helper';
import useWallets from '../../customhooks/wallets/useWallets';

const CreateAccountPrompt = ({
    showPrompt,
    setShowPrompt
}: {
    showPrompt: boolean;
    setShowPrompt: (val: boolean) => void;
}) => {
    const mutation = mutateConfig({ method: 'patch' });

    const { mutate, isLoading } = mutation({
        url: '/corporates/dva'
    });

    const { refetch } = useWallets();

    const handleSubmit = async () => {
        mutate(
            {},
            {
                onSettled: (_, error: AxiosError | undefined | any) => {
                    if (error) {
                        openNotification(
                            'error',
                            getErrorMessage(error) ||
                                'An error occurred, Try again'
                        );
                    } else {
                        setShowPrompt(false);
                        openNotification(
                            'success',
                            'Virtual Account Assigned Successfully'
                        );
                        refetch();
                    }
                }
            }
        );
    };

    return (
        <>
            {showPrompt ? (
                <div className='fixed right-[24px] flex justify-between items-start top-[16px] w-full border border-[#329FC1] bg-[#F7FBFD] max-w-[1050px] rounded-[12px] p-4'>
                    <div className='flex items-start gap-4'>
                        <InfoCircleOutlined className='text-[#0088B2]' />
                        <div>
                            <h2 className='text-[#1E336C] text-[14px] font-semibold leading-[20px] mb-[4px]'>
                                Create new wallet
                            </h2>
                            <p className='text-[#00516A] text-[14px]  leading-[20px] mb-[12px]'>
                                We have a new local currency wallet to make
                                transacting easier on FrontEdge. Click on create
                                now to get started.
                            </p>

                            <button
                                className='flex gap-[12px] items-center text-[#1E336C] text-[14px] font-semibold leading-[20px]'
                                onClick={handleSubmit}
                                disabled={isLoading}
                            >
                                {!isLoading ? (
                                    <>
                                        Create now{' '}
                                        <ArrowRightIcon color='#00516A' />
                                    </>
                                ) : (
                                    'Creating account...'
                                )}
                            </button>
                        </div>
                    </div>
                    <button onClick={() => setShowPrompt(false)}>
                        <CloseIcon color='#1993B9' size={32} />
                    </button>
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default CreateAccountPrompt;
